module.exports = __webpack_public_path__ + "media/applicants/shopper-safety-b60762bf.jpg";